export function normalizeError(err) {
  const safeError = {
    ...err, // enumerable props
    name: err?.name,
    message: err?.message,
    stack: err?.stack,
  };

  return JSON.stringify(safeError);
}
